<div>
  <ng-container *ngIf="row[columnConfig.id]; else imageAlt">
    <img [src]="row[columnConfig.id]" />
  </ng-container>
  <ng-template #imageAlt>{{ columnConfig.imageAlt }}</ng-template>
</div>
